<script setup lang="ts">
import IconCheck from '@/shared/components/UI/Icons/IconCheck.vue';

const props = defineProps<{
  isInsideModal?: boolean;
}>();

const classNames = props.isInsideModal
  ? 'size-6 right-1.5 top-1.5'
  : 'size-5 right-1 top-1';
</script>

<template>
  <div
    :class="classNames"
    class="absolute z-20 grid place-items-center rounded-full bg-primary"
  >
    <IconCheck class="w-3 text-white" />
  </div>
</template>
